export interface MiqTouchable {
  isTouched(): boolean;
  markAsTouched(): void;
}

export const MiqTouchableType: MiqTouchable = {
  isTouched: () => {
    throw new Error('Method not implemented.');
  },

  markAsTouched: () => {
    throw new Error('Method not implemented.');
  },
};
